import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import selectHelper from '../../../../Helpers/selectHelper';
import SearchParamsBase from '../../../../Elements/SearchParamsBase';

export default class TpClientInvoiceJobLineSearchParams extends SearchParamsBase {
  static saveType = 'TpClientInvoiceJobLineSearchParams';
  initialize() {
    this.TpClientInvoiceId = 0;
    this.TpJobThirdPartyIds = '';
    this.UseCompletedDateRange = false;
    this.CompletedBefore = dateTimeHelper.indefiniteDateValue();
    this.CompletedAfter = dateTimeHelper.indefiniteDateValue();
    this.CountryCodes = [];
    this.States = '';
    this.FieldWorkOffices = [];
    this.Statuses = [];
    this.ThirdPartyStatuses = [];
    this.Level1 = '';
    this.Level2 = '';
    this.Level3 = '';
    this.Level4 = '';
    this.Level5 = '';
    this.AdHocGroup = '';
    this.Campaign = '';
    this.TpSurveyId = '';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'TpJobThirdPartyIds',
      label: 'Job Third-Party IDs (id1,id2,id3...)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'UseCompletedDateRange',
      label: 'Completed Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'CompletedBefore',
      label: 'Completed On or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCompletedDateRange,
    },
    {
      fieldName: 'CompletedAfter',
      label: 'Completed On or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCompletedDateRange,
    },
    {
      fieldName: 'CountryCodes',
      label: 'Countries',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'States',
      label: 'States (e.g. PR)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'FieldWorkOffices',
      label: 'Fieldwork office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'Statuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.TpJobStatusMultiSelect,
    },
    {
      fieldName: 'ThirdPartyStatuses',
      label: 'Tp.Status',
      className: 'col-4',
      type: InputTypesEnum.TpJobThirdPartyStatusMultiSelect,
    },
    {
      fieldName: 'Level1',
      label: 'Level 1',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Level2',
      label: 'Level 2',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Level3',
      label: 'Level 3',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Level4',
      label: 'Level 4',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Level5',
      label: 'Level 5',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'AdHocGroup',
      label: 'Ad-Hoc Invoice Group',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Campaign',
      label: 'Campaign',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'TpSurveyId',
      label: 'Survey',
      className: 'col-3',
      type: InputTypesEnum.TpSurveySelect,
      idFilter: () => TpClientInvoiceJobLineSearchParams.getClientId(),
    },
  ];

  // The survey select lists the surveys of one client: the invoice's. The details tab sets this once
  // it has loaded the invoice. It is not a field of the search item, which "Clear all" replaces.
  static getClientId = () => null;
}
